// ##### 25-02-05 Komarov
// import './LoadingMessage.css'
// ##### 24-09-09 Komarov
import parse from 'html-react-parser';
import React from 'react';
import { useSelector } from 'react-redux';
import { useLocalizedText } from '../../../hooks/useLocalizedText.js';

// ##### Komarov 2025-07-14
const NoSearchResultMessageStart = ({ noTextMessage }) => {
  // ##### Komarov 2025-08-05
  const NoSearchResultMessageStart = useLocalizedText('NoSearchResultMessageStart');
  const noSearchResultMessageStart = parse(
    NoSearchResultMessageStart
  );

  return (
    <h3 className="LoadingText" data-component="LoadingMessage">
      {/* ##### 25-01-28 Komarov */}
      {noTextMessage ? null : noSearchResultMessageStart}
    </h3>
  );
};

// ##### 25-05-21 Komarov
export default NoSearchResultMessageStart;
